export const config = {
  publicUrl: process.env.PUBLIC_URL || "https://dashboard.veloxity.net",
  defaultAuth: process.env.REACT_APP_DEFAULTAUTH || "jwt",
  api: process.env.REACT_APP_API_URL
};